import {
  BasicInformationSectionV2,
  CustomRequirementsSectionV2,
  GwiLinkSectionV2,
  SegmentDetailsSectionV2,
} from '../sectionsV2';

export function PersonaInformationStepV2() {
  return (
    <div className="flex flex-col gap-xl">
      <BasicInformationSectionV2 />
      <SegmentDetailsSectionV2 />
      <CustomRequirementsSectionV2 />
      <GwiLinkSectionV2 />
    </div>
  );
}

PersonaInformationStepV2.displayName = 'PersonaInformationStepV2';
